module.exports = __webpack_public_path__ + "img/camCmdAction.d013b4e8.jpg";